module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "step1-form",
    style: ({
      minHeight: (_vm.screenHeight - 85) + 'px'
    })
  }, [_c('div', {
    staticClass: "step-form__step-num"
  }, [_vm._v("2/5")]), _vm._v(" "), (Number(_vm.userInfo.crmCustomerType) === 1) ? _c('div', [_c('div', {
    staticClass: "step-form__main"
  }, [_c('h1', {
    staticClass: "step-form__title"
  }, [_vm._v("个人信息确认")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "step2Form",
    staticClass: "step-form__form",
    attrs: {
      "label-width": '50%',
      "model": _vm.step2Form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "真实姓名",
      "prop": "realName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入真实姓名",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.step2Form.realName),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "realName", $$v)
      },
      expression: "step2Form.realName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "IDCardNum"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入身份证号",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.step2Form.IDCardNum),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "IDCardNum", $$v)
      },
      expression: "step2Form.IDCardNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号码",
      "prop": "cellphone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": "请输入手机号码",
      "maxlength": 11,
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.step2Form.cellphone),
      callback: function($$v) {
        _vm.$set(_vm.step2Form, "cellphone", $$v)
      },
      expression: "step2Form.cellphone"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "step-form__btn-container"
  }, [_c('button', {
    staticClass: "step-form__btn-prev",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('button', {
    staticClass: "step-form__btn-next",
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("下一步")])])], 1)]) : _vm._e(), _vm._v(" "), (Number(_vm.userInfo.crmCustomerType) === 2) ? _c('div', [_c('div', {
    staticClass: "step-form__main"
  }, [_c('h1', {
    staticClass: "step-form__title"
  }, [_vm._v("企业信息确认")]), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 0
    }
  }, [_c('el-col', {
    attrs: {
      "span": 16
    }
  }, [_c('el-form', {
    ref: "step2Form",
    staticClass: "step-form__form",
    attrs: {
      "label-width": '50%',
      "model": _vm.step2FormEnterprise,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "客户名称",
      "required": true,
      "prop": "customerName"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入客户名称",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.step2FormEnterprise.customerName),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "customerName", $$v)
      },
      expression: "step2FormEnterprise.customerName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照号",
      "required": true,
      "prop": "enterpriseNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入营业执照号",
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseNumber),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseNumber", $$v)
      },
      expression: "step2FormEnterprise.enterpriseNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "股东人数",
      "prop": "enterprisePartnerNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入股东人数"
    },
    model: {
      value: (_vm.step2FormEnterprise.enterprisePartnerNumber),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterprisePartnerNumber", $$v)
      },
      expression: "step2FormEnterprise.enterprisePartnerNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册地址",
      "prop": "enterpriseRegAddr"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入注册地址",
      "maxlength": 100,
      "resize": "none",
      "rows": 2
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseRegAddr),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseRegAddr", $$v)
      },
      expression: "step2FormEnterprise.enterpriseRegAddr"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业性质",
      "prop": "enterpriseType"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseType),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseType", $$v)
      },
      expression: "step2FormEnterprise.enterpriseType"
    }
  }, _vm._l((_vm.step2FormEnterprise.enterpriseTypeArray), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册资金",
      "prop": "enterpriseRegMoney"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入注册资金"
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseRegMoney),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseRegMoney", $$v)
      },
      expression: "step2FormEnterprise.enterpriseRegMoney"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.step2FormEnterprise.userType) === 2 ? '法定代表人' : '代理人',
      "required": true,
      "prop": "enterpriseLegalUser"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": Number(_vm.step2FormEnterprise.userType) === 2 ? '请输入法定代表人' : '请输入代理人',
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseLegalUser),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseLegalUser", $$v)
      },
      expression: "step2FormEnterprise.enterpriseLegalUser"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.step2FormEnterprise.userType) === 2 ? '法定代表人身份证号' : '代理人身份证号',
      "required": true,
      "prop": "enterpriseLegalIdNo"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": Number(_vm.step2FormEnterprise.userType) === 2 ? '请输入法定代表人身份证号' : '请输入代理人身份证号',
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseLegalIdNo),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseLegalIdNo", $$v)
      },
      expression: "step2FormEnterprise.enterpriseLegalIdNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.step2FormEnterprise.userType) === 2 ? '法定代表人联系电话' : '代理人联系电话',
      "required": true,
      "prop": "enterpriseLegalUserPhone"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "tel",
      "placeholder": Number(_vm.step2FormEnterprise.userType) === 2 ? '请输入法定代表人联系电话' : '请输入法定代表人联系电话',
      "disabled": _vm.isEditable === 1,
      "maxlength": 11
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseLegalUserPhone),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseLegalUserPhone", $$v)
      },
      expression: "step2FormEnterprise.enterpriseLegalUserPhone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业注册类型",
      "required": true,
      "prop": "registrationType"
    }
  }, [_c('el-radio-group', {
    attrs: {
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.step2FormEnterprise.registrationType),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "registrationType", $$v)
      },
      expression: "step2FormEnterprise.registrationType"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("组织机构代码证号")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("多证合一")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": Number(_vm.step2FormEnterprise.registrationType) === 0 ? '组织机构代码证号' : '社会信用代码号',
      "required": true,
      "prop": "enterpriseOrganizingNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": Number(_vm.step2FormEnterprise.registrationType) === 0 ? '请输入组织机构代码证号' : '请输入社会信用代码号',
      "disabled": _vm.isEditable === 1
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseOrganizingNumber),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseOrganizingNumber", $$v)
      },
      expression: "step2FormEnterprise.enterpriseOrganizingNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业规模",
      "prop": "enterpriseScale"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseScale),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseScale", $$v)
      },
      expression: "step2FormEnterprise.enterpriseScale"
    }
  }, _vm._l((_vm.step2FormEnterprise.enterpriseScaleArray), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "国税登记证号",
      "prop": "enterpriseNationalNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入国税登记证号"
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseNationalNumber),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseNationalNumber", $$v)
      },
      expression: "step2FormEnterprise.enterpriseNationalNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "地税登记证号",
      "prop": "enterpriseNationalNumber"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入地税登记证号"
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseGovernmentNumber),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseGovernmentNumber", $$v)
      },
      expression: "step2FormEnterprise.enterpriseGovernmentNumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "登记机关",
      "prop": "enterpriseRegOrgan"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入登记机关"
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseRegOrgan),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseRegOrgan", $$v)
      },
      expression: "step2FormEnterprise.enterpriseRegOrgan"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "从业人数",
      "prop": "enterpriseEmployeeNum"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "placeholder": "请输入从业人数"
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseEmployeeNum),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseEmployeeNum", $$v)
      },
      expression: "step2FormEnterprise.enterpriseEmployeeNum"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "经营范围",
      "prop": "enterpriseScope"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入经营范围",
      "maxlength": 100,
      "resize": "none",
      "rows": 3
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseScope),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseScope", $$v)
      },
      expression: "step2FormEnterprise.enterpriseScope"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "成立背景",
      "prop": "enterpriseFoundExplain"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "placeholder": "请输入成立背景",
      "maxlength": 100,
      "resize": "none",
      "rows": 6
    },
    model: {
      value: (_vm.step2FormEnterprise.enterpriseFoundExplain),
      callback: function($$v) {
        _vm.$set(_vm.step2FormEnterprise, "enterpriseFoundExplain", $$v)
      },
      expression: "step2FormEnterprise.enterpriseFoundExplain"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "step-form__btn-container"
  }, [_c('button', {
    staticClass: "step-form__btn-prev",
    on: {
      "click": _vm.goBack
    }
  }, [_vm._v("上一步")]), _vm._v(" "), _c('button', {
    staticClass: "step-form__btn-next",
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v("下一步")])])], 1)]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a10c8b02"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/applyLoan/Step2_bak.vue
// module id = 1088
// module chunks = 1